import { Button } from "@itandi/itandi-bb-ui/Button";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import { useState } from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { SubtypeList } from "~/components/specifics/settings/subtypes/SubtypeList";
import { SubtypeModal } from "~/components/specifics/settings/subtypes/SubtypeModal";

export function Page() {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleOpenModal = () => {
		setIsModalOpen(true);
	};
	const handleCloseModal = () => {
		setIsModalOpen(false);
	};

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<Panel>
					<PanelHeader
						rightArea={
							<Button onClick={handleOpenModal} variant="primary">
								追加
							</Button>
						}
						title="案件タイプ設定"
					/>
					<PanelBody>
						<SubtypeList />
					</PanelBody>
				</Panel>
				{isModalOpen ? <SubtypeModal handleClose={handleCloseModal} /> : null}
			</ClientSettingLayout>
		</DefaultV2>
	);
}
